import React from "react";
import { Col, FormGroup, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import FormDropdownField from "src/components/Form/FormDropdownField/FormDropdownField";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import { IOption } from "src/store/models/option.model";
import * as S from "../../../constants/StringConstants";

interface BrokerTasksFormProps {
  selectCarrierTypeList?: IOption[];
  selectStatusTypeList?: IOption[];
  selectRequiredOriginList?: IOption[];
  selectTaskCodeTypeList?: IOption[];
}

export const BrokerTasksForm: React.FC<BrokerTasksFormProps> = ({
  selectCarrierTypeList = [],
  selectStatusTypeList = [],
  selectRequiredOriginList = [],
  selectTaskCodeTypeList = [],
}) => {
  return (
    <>
      <Row>
        <Col sm="6">
          <FormGroup>
            <FormDropdownField name="carrierId" label={S.BRO_TASKS_ADD_FIELD_CARRIER} options={selectCarrierTypeList} />
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <SimpleDatePickerField name="effectiveDate" label={S.BRO_TASKS_ADD_FIELD_EFFECTIVE} isFormMode />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <FormDropdownField
              name="requirementOriginCode"
              label={S.BRO_TASKS_ADD_FIELD_FROM}
              options={selectRequiredOriginList}
            />
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <SimpleDatePickerField name="expirationDate" label={S.BRO_TASKS_ADD_FIELD_EXPIRES} isFormMode />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <FormDropdownField
              name="taskCodeTypeID"
              label={S.BRO_TASKS_ADD_FIELD_CODE}
              options={selectTaskCodeTypeList}
            />
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <SimpleDatePickerField name="receivedDate" label={S.BRO_TASKS_ADD_FIELD_RECEIVED} isFormMode />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <FormDropdownField
              name="taskStatusCode"
              label={S.BRO_TASKS_ADD_FIELD_STATUS}
              options={selectStatusTypeList}
            />
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <SimpleDatePickerField name="orderedDate" label={S.BRO_TASKS_ADD_FIELD_ORDERED} isFormMode />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <CheckboxField name="priority" label={S.BRO_TASKS_ADD_FIELD_PRIORITY} labelPosition="above" />
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <SimpleDatePickerField name="followUpDate" label={S.BRO_TASKS_ADD_FIELD_FOLLOWUP} isFormMode />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <TextField name="description" label={S.BRO_TASKS_ADD_FIELD_DESCRIPTION} multiline />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <TextField name="notes" label={S.BRO_TASKS_ADD_FIELD_NOTES} multiline />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
